import Axios from 'axios';
import * as ApiHelper from '../utils/apiHelper';

export function fetchPromoImage() {
    let path = ApiHelper.API_ROOT + '/settings';

    return new Promise((resolve, reject) => {
        Axios.get(path).then((response) => {
            console.log("promoimage get success", response);
            resolve(response.data[0])
        }).catch((error) => {
            console.log("promoimage get error", error)
            reject({ error: error })
        })
    })
    }


// WEBPACK FOOTER //
// ./src/services/settings.js